import React from 'react'
import { useTranslation } from 'react-i18next'

import { PolicyDocumentURL } from '../../lib/content'
import { RootStackScreenProps } from '../../navigation'

import { TermsAndConditionsBase } from './BaseTermsAndConditions'

type Props = RootStackScreenProps<'SubscriptionTermsAndConditions'>

export const SubscriptionTermsAndConditions: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <TermsAndConditionsBase
      documentURL={PolicyDocumentURL.SubscriptionTerms}
      title={t('screens.subscriptionTermsAndConditions.title')}
    />
  )
}

export default SubscriptionTermsAndConditions
